export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE'


export function changeLanguage(selectedLanguage) {
  return {
    type: CHANGE_LANGUAGE, language: selectedLanguage,
  }
}

export const APP_GET_DATA = 'APP_GET_DATA'

export function appGetData() {
  return {
    type: APP_GET_DATA,
  }
}

export const GET_VENUES = 'GET_VENUES'

export function getVenueList() {
  return {
    type: GET_VENUES,
  }
}

export const GET_NOTIFICATION = 'GET_NOTIFICATION'

export function getNotificationList() {
  return {
    type: GET_NOTIFICATION,
  }
}

export const GET_VENUE_SUCCESS = 'GET_VENUE_SUCCESS'

export function getVenueSuccess(payload) {
  return {
    type: GET_VENUE_SUCCESS, payload,
  }
}

export const GET_TAGS = 'GET_TAGS'

export function getTags() {
  return {
    type: GET_TAGS,
  }
}

export const GET_TAGS_SUCCESS = 'GET_TAGS_SUCCESS'

export function getTagsSuccess(payload) {
  return {
    type: GET_TAGS_SUCCESS, payload,
  }
}

export const SET_SHOW_NAV = 'SET_SHOW_NAV'

export function setShowNav(val) {
  return {
    type: SET_SHOW_NAV, payload: val,
  }
}

export const GET_POS_VERSION = 'GET_POS_VERSION'

export function getPosVersion() {
  return {
    type: GET_POS_VERSION,
  }
}

export const GET_POS_VERSION_SUCCESS = 'GET_POS_VERSION_SUCCESS'

export function getPosVersionSuccess(payload) {
  return {
    type: GET_POS_VERSION_SUCCESS, payload
  }
}

export const GET_SSO_VERSION = 'GET_SSO_VERSION'

export function getVersionSso(payload) {
  return {
    type: GET_SSO_VERSION, payload
  }
}

export const GET_SSO_VERSION_SUCCESS = 'GET_SSO_VERSION_SUCCESS'

export function getSsoVersionSuccess(payload) {
  return {
    type: GET_SSO_VERSION_SUCCESS, payload
  }
}

export const GET_TIER_SUCCESS = 'GET_TIER_SUCCESS'

export function getTierSuccess(payload) {
  return {
    type: GET_TIER_SUCCESS, payload,
  }
}

export const GET_SYSTEM_NOTIFICATION_SUCCESS = 'GET_SYSTEM_NOTIFICATION_SUCCESS'

export function getSystemNotificationSuccess(payload) {
  return {type: GET_SYSTEM_NOTIFICATION_SUCCESS, payload}
}

export const GET_LISTING_TYPE = 'GET_LISTING_TYPE'

export function getListingType() {
  return {
    type: GET_LISTING_TYPE,
  }
}

export const GET_LISTING_TYPE_SUCCESS = 'GET_LISTING_TYPE_SUCCESS'

export function getListingTypeSuccess(payload) {
  return {
    type: GET_LISTING_TYPE_SUCCESS, payload,
  }
}

export const UPDATE_LISTING_TYPE = 'UPDATE_LISTING_TYPE'

export function updateListingType(payload) {
  return {
    type: UPDATE_LISTING_TYPE, payload,
  }
}

export const GET_APP_SETTINGS = 'GET_APP_SETTINGS'

export function getAppSettings() {
  return {
    type: GET_APP_SETTINGS,
  }
}

export const GET_APP_SETTINGS_SUCCESS = 'GET_APP_SETTINGS_SUCCESS'

export function getAppSettingsSuccess(payload) {
  return {
    type: GET_APP_SETTINGS_SUCCESS, payload,
  }
}

export const GET_BEPOZ_CUSTOMFIELD_META = 'GET_BEPOZ_CUSTOMFIELD_META'

export function getBepozCustomFieldMeta() {
  return {
    type: GET_BEPOZ_CUSTOMFIELD_META,
  }
}

export const GET_BEPOZ_CUSTOMFIELD_META_SUCCESS = 'GET_BEPOZ_CUSTOMFIELD_META_SUCCESS'

export function getBepozCustomFieldMetaSuccess(payload) {
  return {
    type: GET_BEPOZ_CUSTOMFIELD_META_SUCCESS, payload
  }
}

export const UPDATE_APP_SETTINGS = 'UPDATE_APP_SETTINGS'

export function updateAppSettings(payload) {
  return {
    type: UPDATE_APP_SETTINGS, payload,
  }
}

export const UPDATE_TIER_SETTINGS = 'UPDATE_TIER_SETTINGS'

export function updateTierSettings() {
  return {
    type: UPDATE_TIER_SETTINGS,
  }
}

export const SET_GLOBAL_INDICATOR_VISIBILITY = 'SET_GLOBAL_INDICATOR_VISIBILITY'

export function setShowGlobalIndicator(visible) {
  return {
    type: SET_GLOBAL_INDICATOR_VISIBILITY, visible
  }
}

export const SET_SYNC_VOUCHER = 'SET_SYNC_VOUCHER'

export function setSyncVoucher(ifSyncVoucher) {
  return {
    type: SET_SYNC_VOUCHER, ifSyncVoucher
  }
}

export const SET_SYNC_PROMOTION = 'SET_SYNC_PROMOTION'

export function setSyncPromotion(ifSyncPromotion) {
  return {
    type: SET_SYNC_PROMOTION, ifSyncPromotion
  }
}

export const GET_LOGIN_SETTING = 'GET_LOGIN_SETTING'
export function getLoginSettings(tierToken) {
  return {
    type: GET_LOGIN_SETTING,
    tierToken,
  }
}

export const GET_LOGIN_SETTING_SUCCESS = 'GET_LOGIN_SETTING_SUCCESS'
export function getLoginSettingsSuccess(payload) {
  return {
    type: GET_LOGIN_SETTING_SUCCESS, payload,
  }
}

export const SET_POPUP_MESSAGE = 'SET_POPUP_MESSAGE'
export function setPopupMessage(payload) {
  return {
    type: SET_POPUP_MESSAGE, payload,
  }
}

